export default {"src":"/kaimono/_next/static/media/questionnaire.59ce4a1c.svg","height":36,"width":26};